import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Privacidad() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Política de Privacidad | Marea Riviera';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#FAFAF7] min-h-screen pt-[120px]">
      <div className="bg-[#0A2235] py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-[#2BBFBF] hover:text-[#7ECFCF] transition-colors mb-8 font-inter text-sm" data-testid="privacy-back-btn">
            <ArrowLeft className="w-4 h-4" /> Volver al inicio
          </button>
          <h1 className="font-playfair text-3xl sm:text-4xl lg:text-5xl text-[#FAFAF7] leading-tight" data-testid="privacy-title">
            Política de Privacidad
          </h1>
          <p className="font-inter text-[#FAFAF7]/50 text-sm mt-4">Última actualización: 3 de julio de 2025</p>
        </div>
      </div>

      <article className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-16" data-testid="privacy-content">
        <div className="prose-marea">
          <h2>1. Responsable del Tratamiento de Datos</h2>
          <p>Marea Riviera, con domicilio en Playa del Carmen, Quintana Roo, México, es responsable del tratamiento de sus datos personales. Contacto: <a href="mailto:mareariviera@outlook.com" className="text-[#2BBFBF]">mareariviera@outlook.com</a></p>

          <h2>2. Datos Personales que Recopilamos</h2>
          <p>A través del formulario de contacto en nuestro sitio web recopilamos los siguientes datos:</p>
          <ul>
            <li>Nombre y apellidos</li>
            <li>Correo electrónico</li>
            <li>Número de teléfono</li>
            <li>Estado o región de residencia</li>
            <li>Monto aproximado de inversión</li>
            <li>Preferencias e intereses de inversión</li>
            <li>Mensajes o comentarios que usted nos comparta</li>
          </ul>

          <h2>3. Finalidad del Tratamiento</h2>
          <p>Los datos personales que nos proporciona serán utilizados para:</p>
          <ul>
            <li>Responder a sus solicitudes de información sobre propiedades e inversiones en Riviera Maya</li>
            <li>Contactarle para brindarle asesoría inmobiliaria personalizada</li>
            <li>Enviarle información relevante sobre oportunidades de inversión que coincidan con su perfil</li>
          </ul>
          <p>No utilizamos sus datos para envío de publicidad masiva ni los compartimos con terceros sin su consentimiento.</p>

          <h2>4. Meta Pixel y Tecnologías de Seguimiento</h2>
          <p>Este sitio web utiliza Meta Pixel, una herramienta de análisis de Facebook/Meta que nos permite medir la efectividad de nuestras campañas publicitarias. Meta Pixel puede recopilar información sobre su visita a este sitio, incluyendo las páginas que consulta y las acciones que realiza.</p>
          <p>Para más información sobre cómo Meta utiliza esta información, consulte la <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer" className="text-[#2BBFBF] underline hover:text-[#7ECFCF] transition-colors">Política de Privacidad de Meta</a>.</p>

          <h2>5. Transferencia de Datos</h2>
          <p>Sus datos personales no serán vendidos, cedidos ni transferidos a terceros, salvo en los siguientes casos:</p>
          <ul>
            <li>Cuando sea requerido por autoridades competentes mediante orden judicial o mandato legal</li>
            <li>A proveedores de servicios tecnológicos que nos asisten en la operación del sitio (como HubSpot para gestión de contactos), quienes están obligados a mantener la confidencialidad de sus datos</li>
          </ul>

          <h2>6. Derechos ARCO</h2>
          <p>De conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), usted tiene derecho a:</p>
          <ul>
            <li><strong>Acceso:</strong> Conocer qué datos personales tenemos sobre usted</li>
            <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos</li>
            <li><strong>Cancelación:</strong> Solicitar la eliminación de sus datos</li>
            <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos</li>
          </ul>
          <p>Para ejercer cualquiera de estos derechos, envíe su solicitud a: <a href="mailto:mareariviera@outlook.com" className="text-[#2BBFBF]">mareariviera@outlook.com</a></p>

          <h2>7. Usuarios Internacionales</h2>
          <p>Si usted accede a este sitio desde la Unión Europea, el Reino Unido o California (EE.UU.), le informamos que:</p>
          <ul>
            <li><strong>GDPR (Europa):</strong> Tratamos sus datos bajo la base legal de interés legítimo para responder a sus consultas. Tiene derecho a solicitar la eliminación de sus datos en cualquier momento.</li>
            <li><strong>CCPA (California):</strong> No vendemos sus datos personales a terceros.</li>
          </ul>
          <p>Para ejercer sus derechos bajo cualquiera de estas regulaciones, contáctenos en <a href="mailto:mareariviera@outlook.com" className="text-[#2BBFBF]">mareariviera@outlook.com</a></p>

          <h2>8. Retención de Datos</h2>
          <p>Conservamos sus datos personales durante el tiempo necesario para atender su solicitud y, en caso de convertirse en cliente, durante la vigencia de nuestra relación comercial más el período que establezca la legislación aplicable.</p>

          <h2>9. Cambios a esta Política</h2>
          <p>Nos reservamos el derecho de actualizar esta política de privacidad en cualquier momento. Cualquier cambio será publicado en esta página con la fecha de actualización correspondiente.</p>

          <h2>10. Contacto</h2>
          <p>Para cualquier duda o solicitud relacionada con el tratamiento de sus datos personales:</p>
          <p><strong>Marea Riviera</strong><br />Playa del Carmen, Quintana Roo, México<br /><a href="mailto:mareariviera@outlook.com" className="text-[#2BBFBF]">mareariviera@outlook.com</a><br />+52 984 158 5732</p>
        </div>
      </article>
    </div>
  );
}
